import { TabLabelStyle } from './SlideTabLabel.style';

type SlideTabLabelProps = {
  index: number;
  thumbnail?: string;
};

export const SlideTabLabel = ({ index, thumbnail }: SlideTabLabelProps) => (
  <TabLabelStyle>
    {thumbnail ? (
      <img src={thumbnail} alt="" className="tab-thumbnail" />
    ) : (
      <div className="tab-placeholder" />
    )}
    <span className="tab-number">슬라이드 {index + 1}</span>
  </TabLabelStyle>
);
